import {CacheKeyConfig, useGrpcRequest} from '@aboutyou/data-fetcher';
import {BasketService_GetMinimalState} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/service.grpc';
// eslint-disable-next-line monorepo/no-internal-import
import {useSelectedDiscountRequestParameter} from '@aboutyou/logic-components/src/backend-services/Campaigns/SelectedDiscounts/useSelectedDiscount';
import {useFullSession} from '../userStore/useSession';
import {usePersistSessionStateCallback} from '../sessionStore/session.hooks';
import {GetMinimalStateResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/service.types';
import {createDataStore} from '../createDataStore';
import {useBasketToken} from './BasketTokenProvider';

const useExpensiveBasket = () => {
  const session = useFullSession();
  const selectedDiscount = useSelectedDiscountRequestParameter();
  const persistSessionState = usePersistSessionStateCallback();
  const {updateBasketToken, basketTokenHash, token} = useBasketToken();

  const response = useGrpcRequest(
    BasketService_GetMinimalState,
    {selectedDiscount, session: session!, basketToken: token},
    {
      // it will fail without it as session can and will be null for first render
      disabled: !session,
      refetchToken: basketTokenHash,
      onSuccess: (minimalState?: GetMinimalStateResponse) => {
        updateBasketToken(minimalState?.basketToken);
        const hasItemsInBasket = Boolean(minimalState?.state.totalQuantity);
        // we want to delay persisting of the session state as much as possible for legal reasons
        // if an anonymous user doesn't have anything in the basket/basket/or is loggedIn, we don't need to persist the session-id
        if (hasItemsInBasket) {
          persistSessionState();
        }
      },
      transformCacheKey: (config: CacheKeyConfig) => {
        return {
          ...config,
          params: {
            ...config.params,
            basketToken: undefined,
          },
        };
      },
    },
  );

  return response;
};

const {Provider, useData: useBasketMinimalState} =
  createDataStore<GetMinimalStateResponse>({
    defaultValue: undefined,
    useQueryHook: useExpensiveBasket,
  });

export {Provider as MinimalStateProvider, useBasketMinimalState};
